import React from 'react';
import PhysicianDirectory from './components/physician-directory/physicianDirectory';
import Locations from './components/locations/locations';

const physician_directory = document.getElementById('PhysicianDirectory');
const locations = document.getElementById('Locations');

function App() {
  return (
    <>
        {physician_directory && <PhysicianDirectory data-items-per-page="10"></PhysicianDirectory>}
        {locations && <Locations></Locations>}
    </>
  );
}

export default App;
